export default __webpack_public_path__ + "7b9c9c6b919eae9407f831093db570f0.png";